// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:7622ca4f-a918-4512-b7c4-8411a0e6d5fd',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_i7JuoCqad',
    aws_user_pools_web_client_id: '5n6jv3uo1eqp1vmm545u91h6hl',
    oauth: {
        domain: 'betterspace-prod-dev-dev.auth.eu-west-2.amazoncognito.com',
        scope: [
            'phone',
            'email',
            'openid',
        ],
        redirectSignIn: 'http://localhost:3000/callback',
        // redirectSignIn: 'https://dev-user.betterspace.uk/callback',
        redirectSignOut: 'http://localhost:3000/logout',
        // redirectSignOut: 'https://dev-user.betterspace.uk/logout',
        responseType: 'token',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cloud_logic_custom: [
        {
            name: 'AdminQueries',
            endpoint: 'https://jqey6bjwqj.execute-api.eu-west-2.amazonaws.com/dev',
            region: 'eu-west-2',
        },
    ],
    aws_content_delivery_bucket: 'webapp-production-betterspace-dev',
    aws_content_delivery_bucket_region: 'eu-west-2',
    aws_content_delivery_url: 'https://d2k4nh4l4iqha3.cloudfront.net',
}

export default awsmobile
